import React, { createContext, useContext, useEffect, useState } from "react";
import { auth, signInWithStagingCustomToken } from "../firebase";
import { Frame, } from "@shopify/polaris";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const stripe = loadStripe(
  process.env.NODE_ENV === 'production'
    ? 'pk_live_51NE8qjA8I6Mhcszp6f5GBLr6eFO9KrHOgRLeS5ZzWrwzyEJIhJDkkQS13N9uG2ILPEw6QaMR7ZU6jCehg4zbRTaV00JiSGcSJK'
    : 'pk_test_51NE8qjA8I6Mhcszp01dFjVUJMuVxyD7AzaMDmPNNqaYLqSvkynEbQHQudfgYJDaHYmm9cYRCR0tk58XSVerEJ0Va006wphrqNo'
)

export const PartnerUpContext = createContext({});
export const usePartnerUp = () => useContext(PartnerUpContext);

export default function PartnerUpProvider({ children }) {

  useEffect(() => {
    // get impersonate query param
    const urlParams = new URLSearchParams(window.location.search);
    const uid = urlParams.get('uid');

    if (uid) {
      signInWithStagingCustomToken(uid)
    }
  }, [])

  return (
    <PartnerUpContext.Provider value={{
      signOut: async () => {
        await auth.signOut()
        window.location.reload();
      },
    }}>
      <Elements stripe={stripe}>
        <Frame>
          {children}
        </Frame>
      </Elements>
    </PartnerUpContext.Provider>
  );
};

